<template>
  <div>
    <el-collapse v-model="activeCollapses" class="collapse-main-content">
      <!--反馈信息-->
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            反馈信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseInfoData1"
            :columns="baseColumns1"
            :rules="baseRules1"
            :isDisabledForm="disableBaseFormData"
            :isQueryPanel="false"
            labelWidth="120px"
          >
          </SiruiSearch>
        </div>
      </el-collapse-item>
      <!--反馈处理-->
      <el-collapse-item name="2" v-if="this.pageMode == 1 || this.pageMode == 3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            反馈处理
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseInfoData2"
            :columns="baseColumns2"
            :rules="baseRules2"
            :isDisabledForm="disableBaseFormData1"
            :isQueryPanel="false"
            @changeMethod="changeMethod"
            labelWidth="120px"
          >
          </SiruiSearch>
        </div>
      </el-collapse-item>
      <!--附件-->
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="cpllapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="attachments"
            :isShowDownBtn="this.pageMode == 1 || this.pageMode == 3"
            :fileType="fileType"
            :fileSize="fileSize"
            :limitFileCount="10"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="text-center" v-if="this.pageMode == 0 || this.pageMode == 2">
      <el-button type="primary" @click="saveClick">保存</el-button>
      <el-button @click="cancelClick">取消</el-button>
    </div>
    <div class="text-center" v-if="this.pageMode == 3">
      <el-button type="primary" @click="handleClick">处理</el-button>
      <el-button @click="cancelClick">取消</el-button>
    </div>
  </div>
</template>

<script>
  import { tableColumns1, tableColumns2 } from './columns/tableColumns.js';
  import { baseRules1, baseRules2 } from './columns/tableRules.js';
  import FeedbackServiceMixin from '../mixins/feedbackServiceMixin.js';
  export default {
    name: 'feedbackCreate',
    mixins: [FeedbackServiceMixin],
    data() {
      return {
        // attachments: [],
        activeCollapses: ['1', '2', '3'],
        baseRules1: baseRules1,
        baseRules2: baseRules2,
        // 反馈信息
        baseInfoData1: {
          contactWay: '',
          createPersonName: '',
          feedbackContent: '',
          feedbackDate: '',
          feedbackPersonName: '',
          processStatus: '',
          gmtCreate: '',
          title: '',
          id: null,
        },
        baseInfoData2: {
          processPersonName: '',
          processPersonNo: '',
          processPlan: '',
          processDateShow: '',
        },
        // 0 新增，1详情，2编辑，3处理
        pageMode: 0,
        id: null,
        fileType: ['xls', 'xlsx', 'txt', 'doc', 'docx', 'pdf', 'jpg'],
        fileSize: 10,
      };
    },
    computed: {
      baseColumns1() {
        return tableColumns1(this);
      },
      baseColumns2() {
        return tableColumns2(this);
      },
      disableBaseFormData() {
        return this.pageMode == 1 || this.pageMode == 3;
      },
      disableBaseFormData1() {
        return this.pageMode == 1;
      },
    },
    mounted() {
      if (this.$route.query?.pageMode) {
        this.pageMode = Number(this.$route.query?.pageMode);
        this.id = this.$route.query?.id;
      }
      console.log('mounted');
      this.init();
    },
    methods: {
      changeMethod({ val, prop }) {
        console.log(val, prop);
        if (prop == 'processPersonNo') {
          this.baseInfoData2.processPersonName = val[0].personName;
          this.baseInfoData2.processPersonNo = val[0].personNo;
        }
      },
      async init() {
        await this.initDetail();
      },
      //保存
      saveClick() {
        this.save(this.baseInfoData1, this.id);
      },
      //处理的回调
      handleClick() {
        this.handle(this.baseInfoData1, this.baseInfoData2, this.id);
      },
      //取消
      cancelClick() {
        this.$confirm('确认取消吗', '提示')
          .then(() => {
            // this.$router.push(path);
            this.closeCurrentAndToList();
          })
          .catch(() => {
            console.log('取消');
          });
      },
    },
  };
</script>

<style></style>
